const GET_PROFILE_WISHLIST_REQUEST = 'GET_PROFILE_WISHLIST_REQUEST';
const GET_PROFILE_WISHLIST_SUCCESS = 'GET_PROFILE_WISHLIST_SUCCESS';
const GET_PROFILE_WISHLIST_FAILURE = 'GET_PROFILE_WISHLIST_FAILURE';

import * as backend from 'backend-helpers/profileWishlist';
import {BobTVUser} from 'bobtvuser';

const initState = {
    user: new BobTVUser({}),
    online: null,
    wishlist: []
};

export default function profileWishlist(state = initState, action) {
    if (action.type === GET_PROFILE_WISHLIST_SUCCESS) {
        let {status, user, ...rest} = action.result;

        return {
            ...state,
            ...rest,
            user: new BobTVUser(user)
        }
    }

    if (action.type === GET_PROFILE_WISHLIST_FAILURE) {
        let {error, ...rest} = action.result;

        console.log('GET_PROFILE_WISHLIST_FAILURE:', error);

        return {
            ...state,
            user: new BobTVUser({_loaded: false, _notFound: true})
        }
    }

    return state;
}

export function getProfileWishlist(nick) {
    return {
        types: [GET_PROFILE_WISHLIST_REQUEST, GET_PROFILE_WISHLIST_SUCCESS, GET_PROFILE_WISHLIST_FAILURE],
        promise: backend.getProfileWishlist(nick)
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profileWishlist.js